import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { AuthorizationGate } from './components/Authorization'
import { Browser, Menu } from './components/events'

const layoutStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}

const contentStyle = {
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  padding: '8px'
}

export const EventsHome = () => {
  const { data, assignedCount } = useSelector((state) => state?.schedule)

  return (
    <Box sx={layoutStyle}>
      <Menu assignedCount={assignedCount} />
      <Box sx={contentStyle}>
        <Browser data={data} />
      </Box>
    </Box>
  )
}

export const EventsFavorite = () => {
  const { favorite, assignedCount } = useSelector((state) => state?.schedule)

  return (
    <Box sx={layoutStyle}>
      <Menu assignedCount={assignedCount} />
      <Box sx={contentStyle}>
        <Browser data={favorite} noData={{ label: 'nothing here - events', icon: (<AddCircleOutlineIcon className="error-icon"/>) }}/>
      </Box>
    </Box>
  )
}

export const EventsAssigned = () => {
  const { assigned, assignedCount } = useSelector((state) => state?.schedule)

  return (
    <AuthorizationGate redirect="/events">
      <Box sx={layoutStyle}>
        <Menu assignedCount={assignedCount} />
        <Box sx={contentStyle}>
          <Browser data={assigned} noData={{ label: 'nothing here - assigned' }} />
        </Box>
      </Box>
    </AuthorizationGate>
  )
}
